import React, { useEffect, useRef, useState } from "react";
import "../../../pages/analytics/analytics.css";
import "../../PaymentReconciliation/uploadModal.css";
import { Alert, Dialog, DialogActions, ListItemText, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import CustomButton from "../../../reusableComponents/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import UploadErrorScenarios from "../../PaymentReconciliation/UploadErrorScenarios";
import { colorBrandObject } from "../../../../constants/brandings";
import CustomDropdown from "../../../reusableComponents/CustomDropdown";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MonthYearPicker, { convertMonthYearToMidISO } from "../../../reusableComponents/MonthYearPicker/MonthYearPicker";
import { useParams } from "react-router-dom";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          variant="determinate"
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor: colorBrandObject.primaryButtonColor,
            },
            height: 6,
          }}
          {...props}
        />
      </Box>
      <Box sx={{ minWidth: 50 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {props.value < 1 ? 0 : props.value === 100 ? 100 : props.value}%
        </Typography>
      </Box>
    </Box>
  );
}
const UploadModal = ({
  handleCloseUploadModal,
  toggleDialog,
  type,
  modalDetails,
  dropDownInfo,
  getTableData,
}) => {
  const [selectedFile, setSelectedFile] = useState();
  const [fileError, setFileError] = useState();
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [options, setOptions] = useState([])
  const [inputInfo, setInputInfo] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [uploadFileErrors, setUploadFileErrors] = useState();
  const [fileUploadPercentage, setFileUploadPercentage] = useState(0);
  const [cancelModal, setCancelModal] = useState(false);
  const uploadControllerRef = useRef();
  const [mandatoryFields, setMandatoryFields] = useState([])
  const [showRequiredColumns, setShowRequiredColumns] = useState(false)
  const [isOpenSelect, setIsOpenSelect] = useState(true)
  const [selectedDate, setSelectedDate] = useState('')

  const { globalFileUpload, handleApiError, getUserDetails } = useAuth();
    const { reconId } = useParams();
  

  // section validations 
  const showUploadFileContainer = !loadingFile && !selectedFile && !uploadingFile && !uploadFileErrors
  const showSelectedFileNameSection = selectedFile && !loadingFile && !uploadingFile && !uploadFileErrors
  const disableSubmitButton = !selectedFile || uploadingFile || (inputInfo && !inputInfo?.recordInstantExpression && !selectedDate)


  const handleAbortApi = () => {
    if (typeof uploadControllerRef?.current?.abort === "function") {
      if (uploadControllerRef?.current) {
        uploadControllerRef.current.abort();
      }
    }

    handleCloseUploadModal();
    setSelectedFile(null);
  };
  const uploadAgain = () => {
    setUploadingFile(false);
    setUploadFileErrors(false);
  };

  const handleOutlinedClicked = () => {
    if (uploadingFile) {
      setCancelModal(true);
      return;
    }
    handleCloseUploadModal();
    setSelectedFile(null);
  };


  const handleFileUpload = () => {
    try {
      uploadControllerRef.current = new AbortController();

      setUploadingFile(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      if (selectedDate) {

        formData.append("recordsTimestamp", selectedDate);
      }
      const merchantID = getUserDetails()?.merchantId;
      globalFileUpload(
        `/merchants/${merchantID}/generic-reconciliations/reconciliations/${reconId}/file-sets/${selectedValue}/recon-record-files`,
        formData,
        function () {
          customToast("success", "high", "Upload Successful");
          getTableData();
          handleCloseUploadModal();
          setUploadingFile(false);
        },
        function (err) {
          if (err?.code === "ERR_CANCELED") {
          } else if (
            err?.response?.status === 415 ||
            err?.response?.status === 400
          ) {
            setUploadFileErrors(err);
            setUploadingFile(false);
          } else {
            handleApiError(err, (errMsg) =>
              customToast(
                "error",
                "high",
                errMsg ? errMsg : "Unexpected error occurred. Try again later."
              )
            );
            handleCloseUploadModal();
            setUploadingFile(false);
          }
        },
        function (progressEvent) {
          const percentCompleteNum =
            (progressEvent.loaded / progressEvent.total) * 100;
          const percentComplete = percentCompleteNum.toFixed(1);

          setFileUploadPercentage(percentComplete);
        },
        uploadControllerRef.current
      );
    } catch (err) { }
  };

  const handleSubmit = () => {
    if (uploadFileErrors) {
      setSelectedFile(null);
      setLoadingFile(false);
      uploadAgain();
    } else {
      handleFileUpload();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleCloseUploadModal();
      setSelectedFile(null);
    }
  };

  const handleBrowse = (event) => {
    event.preventDefault();

    setLoadingFile(true);
    const file = event?.target?.files[0];
    const allowedExtensions = inputInfo?.fileExtensions;
    const regex = new RegExp(`\\.(${allowedExtensions.join("|")})$`, "i");
    if (file.name.match(regex)) {
      setFileError(null);
      const fileSizeInBytes = file.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;

      if (file) {
        setSelectedFile(file);
      }
    } else {
      setLoadingFile(false);
      setFileError("invalid format");
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();

    try {
      setLoadingFile(true);
      const droppedFile = event?.dataTransfer?.files[0];
      const allowedExtensions = inputInfo?.fileExtensions;
      const regex = new RegExp(`\\.(${allowedExtensions.join("|")})$`, "i");
      if (droppedFile.name.match(regex)) {
        setFileError(null);

        if (droppedFile) {
          setSelectedFile(droppedFile);
        }
      } else {
        setLoadingFile(false);
        setFileError("invalid format");
      }
    } catch (err) {
      customToast("error", "high", "Something Went Wrong");
      handleCloseUploadModal();
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleValueSet = (value) => {
    setSelectedValue(value);
    const inputInfoData = dropDownInfo.find(
      (el) => el.fileSetCode?.toLowerCase() == value?.toLowerCase()
    );
    if (inputInfoData) {
      setInputInfo(inputInfoData);
      if (Array.isArray(inputInfoData?.fieldsOfInterest) && inputInfoData?.fieldsOfInterest?.length) {
        setMandatoryFields(inputInfoData?.fieldsOfInterest)
      }
    }
  }

  const handleValueSelect = (event) => {

    const {
      target: { value },
    } = event;
    handleValueSet(value)
  };

  useEffect(() => {
    if (selectedFile) {
      setLoadingFile(false);
    }
  }, [selectedFile]);

  const handleCloseCancelModal = () => {
    setCancelModal(false);
  };
  useEffect(() => {
    if (dropDownInfo) {
      const filteredInfo = dropDownInfo.filter(
        (el) =>
          el.fileTypeCode?.toLowerCase() ==
          modalDetails.fileTypeCode?.toLowerCase()
      );

      let overAllOptions = []
      for (let i = 0; i < filteredInfo?.length; i++) {
        if (filteredInfo[i]) {

          overAllOptions.push({ title: filteredInfo[i].fileSetTitle, value: filteredInfo[i].fileSetCode })
        }
      }

      if (overAllOptions?.length > 0) {
        setOptions(overAllOptions)
      }

      if (overAllOptions?.length == 1) {
        handleValueSet(overAllOptions[0].value);
      }
    }
  }, [dropDownInfo]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (event) {
        event.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const handleDateChange = (value) => {
    if (!value) return
    const convertedDate = convertMonthYearToMidISO(value)
    setSelectedDate(convertedDate)
  };
  return (
    <>
      <Dialog
        open={toggleDialog}
        PaperProps={{
          style: {
            backgroundColor: "#FFF",
            borderRadius: "12px",
            maxWidth: "640px",
            padding: "32px 32px 25px 32px",
          },
        }}
        onKeyDown={handleKeyDown}
      >
        <div className="upload-modal">
          <div className="upload-modal-header">
            <Typography className="headerH1Bold" style={{ fontSize: "26px" }}>
              Upload file
            </Typography>
            <CloseIcon
              sx={{ height: "24px", width: "24px", cursor: "pointer" }}
              onClick={handleOutlinedClicked}
            />
          </div>


          <div className="mb-3" >
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end"
            }}>
              {options?.length > 1 && (
                <div style={{ width: "48%" }}>
                  <Typography
                    className="labelRegular"
                    style={{ color: "var(--global-neutral-grey-1100, #2D2B32)" }}
                  >
                    Select Insurer*
                  </Typography>
                  <Select
                    className="selectField"
                    value={selectedValue}
                    disabled={uploadingFile}
                    onChange={handleValueSelect}
                    classes={{ icon: "custom-dropdown-icon" }}
                    MenuProps={{
                      PaperProps: { style: { maxHeight: 250 } },
                    }}
                    displayEmpty
                    open={isOpenSelect} // Control the open state
                    onClose={() => setIsOpenSelect(false)} // Close handler
                    onOpen={() => setIsOpenSelect(true)} // Open handler

                    renderValue={(selected) => {
                      if (!selected) {
                        return <span style={{ opacity: "0.5", fontSize: "16px" }}>{`Select ${modalDetails?.fileTypeTitle} `}</span>;
                      }
                      const found = options.filter(el => el.value == selected)


                      return found?.length ? found[0]?.title : selectedValue;

                    }}
                  >
                    {options?.map((item) => (
                      <MenuItem
                        key={item?.value}
                        value={item?.value}
                        className="businessUnit businessUnitCheckbox"
                        style={{ padding: "5px 10px", height: "40px" }}
                      >
                        <div className="ellipsisListItemInsurer" style={{ maxWidth: "300px" }}>
                          {item?.title?.length > 30 ? (
                            <Tooltip title={item?.title}>
                              <ListItemText primary={item?.title} />
                            </Tooltip>
                          ) : (
                            <ListItemText primary={item?.title} />
                          )}
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}

              {inputInfo && !inputInfo?.recordInstantExpression && <div style={{ width: "48%" }}>
                <Typography
                  className="labelRegular"
                  style={{ color: "var(--global-neutral-grey-1100, #2D2B32)", marginBottom: 8 }}
                >
                  Select Month*
                </Typography>
                <MonthYearPicker
                  label="Pick a Month and Year *"
                  minDate="2023-01-01"
                  disabled={uploadingFile}
                  disableFuture={true}
                  onChange={handleDateChange}
                />
              </div>}
            </div>
          </div>

          {showUploadFileContainer && (
            <>
              <div
                className="upload-area"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                accept={
                  inputInfo?.fileExtensions?.length
                    ? inputInfo?.fileExtensions
                      ?.map((ext) => `.${ext}`)
                      .join(", ")
                    : ""
                }
              >
                <form
                  onClick={() => document?.querySelector(".upload-field").click()}
                >
                  <input
                    type="file"
                    accept={
                      inputInfo?.fileExtensions?.length
                        ? inputInfo?.fileExtensions
                          .map((ext) => `.${ext}`)
                          .join(", ")
                        : ""
                    }
                    className="upload-field"
                    hidden
                    onChange={handleBrowse}
                    disabled={!selectedValue}
                  />
                  <img
                    src="/assets/routingIcons/upload.svg"
                    height={"40px"}
                    width={"40px"}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "16px",
                    }}
                  >
                    <Typography
                      className="bodyB2SemiBold "
                      style={{ color: "#01010299", fontSize: "16px" }}
                    >
                      Drag & Drop your file here
                    </Typography>
                    <Typography>
                      <span>or </span>
                      <span
                        style={{
                          color: `${colorBrandObject?.primaryButtonColor}`,
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "18px",
                        }}
                      >
                        Browse from computer
                      </span>
                    </Typography>
                    {inputInfo?.fileExtensions?.length > 0 && (
                      <Typography
                        style={{
                          color: "#01010299",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "18px",
                          marginTop: "20px",
                        }}
                      >
                        <span>Supported Formats: </span>
                        {inputInfo?.fileExtensions?.map((el, index) => (
                          <span>
                            .{el?.toLowerCase()}{" "}
                            {index < inputInfo?.fileExtensions?.length - 1 &&
                              " , "}
                          </span>
                        ))}{" "}
                      </Typography>
                    )}

                    {fileError && (
                      <div className="error">
                        <img src="/assets/errorOutline.svg" />
                        <Typography
                          className="labelRegular"
                          style={{
                            color: "var(--comms-negative, #B9232F)",
                            padding: "2px 0px 6px 0px",
                          }}
                        >
                          {fileError}
                        </Typography>
                      </div>
                    )}
                  </div>
                </form>


              </div>
              {!!mandatoryFields?.length &&
                <Alert
                  sx={{
                    border: "1px solid var(--Global-Squash-300, #FFE9BA)",
                    background: "#FFF6DA",
                    boxShadow: "0px 1.5px 4px -1px rgba(10, 9, 11, 0.07)",
                    padding: 1,
                    marginTop: "24px",
                    '& .MuiAlert-message': {
                      padding: 0,
                    },
                  }}
                  icon={false}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <img src="/assets/info-circle-yellow.svg" style={{ marginTop: "4px" }} />

                    <div>

                      <Typography
                        style={{
                          color: " var(--Global-Neutral-Grey-1300, #0A090B)",
                          fontSize: "12px",
                          fontWeight: 400,
                          textAlign: "left"

                        }}
                      >
                        {mandatoryFields?.length < 6 ? <> Please note, to prevent errors, please make sure the columns  <span style={{ fontWeight: "600" }}> {mandatoryFields?.join(" , ")} </span>  are present in the files you upload.</> : <>
                          Please note, to prevent errors, please make sure following columns are present in the files you upload. <span onClick={() => setShowRequiredColumns(true)} style={{ color: "#403E9F", textDecoration: "underLine", fontWeight: "500", cursor: "pointer" }}>View Columns</span>
                        </>}
                      </Typography>
                    </div>
                  </div>
                </Alert>
              }
            </>
          )}
          {!selectedFile && loadingFile && !uploadFileErrors ? (
            <div className="error-area" style={{ gap: "16px" }}>
              <CircularProgress
                sx={{
                  height: "40px",
                  width: "40px",
                }}
              />
              <Typography
                className="bodyB2RegularText"
                sx={{
                  color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                }}
              >
                Loading file ...
              </Typography>
            </div>
          ) : (
            showSelectedFileNameSection && (
              <div className="error-area" style={{ gap: "16px" }}>
                <InsertDriveFileOutlinedIcon
                  sx={{
                    height: "40px",
                    width: "40px",
                    color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                  }}
                />
                <Typography
                  className="bodyB1SemiBold"
                  sx={{
                    color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                  }}
                >
                  {selectedFile?.name}
                </Typography>
              </div>
            )
          )}
          {uploadingFile && !uploadFileErrors && (
            <div className="error-area" style={{ gap: "16px" }}>
              <Box sx={{ width: "100%" }}>
                <LinearProgressWithLabel value={fileUploadPercentage} />
              </Box>

              <Typography
                className="bodyB2RegularText"
                sx={{
                  color: "rgba(79, 77, 85, 1)",
                }}
              >
                Please wait your file is uploading
              </Typography>
            </div>
          )}
          {uploadFileErrors && (
            <div className="error-area" style={{ gap: "8px" }}>
              <UploadErrorScenarios uploadFileErrors={uploadFileErrors} />
            </div>
          )}
        </div>

        <SmallModal
          toggleDialog={cancelModal}
          headerText={"Cancel Upload"}
          subHeaderText={"Are you sure you want to cancel?"}
          outlinedBtnText={"No"}
          outlinedBtnFunction={handleCloseCancelModal}
          filledBtnText={"Yes"}
          filledBtnFunction={handleAbortApi}
        />
        <DialogActions
          className=""
          sx={{ border: "0px", display: "flex", marginTop: "24px" }}
        >
          <CustomButton
            text={"Cancel"}
            variant={"outlined"}
            type={"secondary"}
            size={"md"}
            onClick={handleOutlinedClicked}
          />

          <CustomButton
            text={uploadFileErrors ? "Upload again" : "Upload"}
            disabled={disableSubmitButton}
            variant={"contained"}
            type={"secondary"}
            size={"md"}
            onClick={handleSubmit}
          />
        </DialogActions>
      </Dialog>


      {showRequiredColumns && (
        <Dialog
          open={showRequiredColumns}
          onKeyDown={(event) => {
            if (event?.key === "Escape") {
              setShowRequiredColumns(false)
            }
          }}
          PaperProps={{
            sx: {
              maxWidth: "700px",
              width: "650px",
              margin: "auto",
              borderRadius: "12px",
            },
          }}
        >
          <div style={{ padding: "24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography className="headerH1Bold font-black-highest">
                  Required Columns
                </Typography>
              </div>
              <CloseIcon
                sx={{ height: "24px", width: "24px", cursor: "pointer" }}
                onClick={() => setShowRequiredColumns(false)}
              />
            </div>
            <Typography className="labelRegular font-black-high">
              Please ensure the following columns are included in the files before uploading
            </Typography>

            <div
              style={{
                border: "1px solid #E4E4E4",
                borderRadius: "12px",
                marginTop: "24px",
                padding: "2px"
              }}
            >
              <ul
                style={{
                  height: "300px",
                  overflowY: "scroll",
                  padding: "18px",
                  listStyleType: "disc",
                  listStylePosition: "inside",
                  display: "flex",
                  flexWrap: "wrap"
                }}
              >
                {mandatoryFields?.map((el, index) => (
                  <li
                    key={index}
                    style={{
                      color: "#010102EB",
                      fontSize: "14px",
                      fontWeight: "500",
                      marginBottom: "8px",
                      width: "50%",
                    }}
                  >
                    {el}
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ textAlign: "right", marginTop: "24px" }}>

              <CustomButton
                text={"Got It"}
                variant={"contained"}
                type={"secondary"}
                size={"md"}
                onClick={() => setShowRequiredColumns(false)}
              />
            </div>

          </div>
        </Dialog>
      )}


    </>
  );
};

UploadModal.defaultProps = {
  handleCloseUploadModal: () => { },
  toggleDialog: false,
  type: "primary",
};

export default UploadModal;
